export default defineNuxtPlugin(() => {
  if (import.meta.client && 'serviceWorker' in navigator) {
    // Listen for cleanup message from old service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SW_CLEANUP') {
        console.warn('[SW Plugin] Old service worker cleaned up, reloading...')
        setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    })

    // Register service worker on page load
    window.addEventListener('load', async () => {
      try {
        // First, unregister any OLD service workers (not our new sw.js)
        const registrations = await navigator.serviceWorker.getRegistrations()
        console.warn('[SW Plugin] Found', registrations.length, 'service worker(s)')

        for (const registration of registrations) {
          const scriptURL = registration.active?.scriptURL || registration.installing?.scriptURL || registration.waiting?.scriptURL
          console.warn('[SW Plugin] Checking:', scriptURL)

          // Only unregister if it's NOT our new sw.js
          if (scriptURL && !scriptURL.endsWith('/sw.js')) {
            await registration.unregister()
            console.warn('[SW Plugin] Unregistered old service worker:', scriptURL)
          }
          else {
            console.warn('[SW Plugin] Keeping existing sw.js')
          }
        }

        // Register the new service worker
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
        })

        console.warn('[SW Plugin] Service worker registered:', registration.scope)

        // Check for updates periodically
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker)
            return

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.warn('[SW Plugin] New version available! Reloading...')
              newWorker.postMessage({ type: 'SKIP_WAITING' })

              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          })
        })

        // Listen for controller change (new service worker activated)
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.warn('[SW Plugin] New service worker activated, reloading page')
          window.location.reload()
        })

        // Check for updates every hour
        setInterval(() => {
          registration.update()
        }, 60 * 60 * 1000)
      }
      catch (error) {
        console.error('[SW Plugin] Service worker registration failed:', error)
      }
    })

    // Force clear cache and reload
    const clearCacheAndReload = async () => {
      try {
        const cacheKeys = await window.caches.keys()
        console.warn('[SW Plugin] Clearing', cacheKeys.length, 'cache(s):', cacheKeys)
        await Promise.all(
          cacheKeys.map(cache => window.caches.delete(cache)),
        )
        console.warn('[SW Plugin] All caches cleared, reloading...')
        window.location.reload()
      }
      catch (error) {
        console.error('[SW Plugin] Cache clear failed:', error)
      }
    }

    // Expose cache clear function globally for debugging
    // @ts-expect-error: Adding to window for debugging
    window.__clearCache = clearCacheAndReload
    console.warn('[SW Plugin] Debug: Run window.__clearCache() to force clear all caches')
  }
})
